// reducer.js
import { FETCH_USER_ROLE_SUCCESS, FETCH_USER_ROLE_ERROR,LOGIN_SUCCESS,LOGIN_ERROR,LOGIN_WITH_OTP_SUCCESS,LOGIN_WITH_OTP_ERROR, RESET_PASSWORD_SUCCESS, RESET_PASSWORD_ERROR, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_ERROR, GET_PROFILE_SUCCESS, GET_PROFILE_ERROR } from '../actionTypes';

export const loginInitialState = {
  data: null,
  error: null,
  login:null,
  otp:null,
  message: null
};

export default (state = loginInitialState, action) => {
  switch (action.type) {
    case FETCH_USER_ROLE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
      };
    case FETCH_USER_ROLE_ERROR:
      return {
        ...state,
        data: null,
        error: action.payload,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        login: action.payload,
        error: null,
      };
    case LOGIN_ERROR:
      return {
        ...state,
        login: null,
        error: action.payload,
      };
    case LOGIN_WITH_OTP_SUCCESS:
      return {
        ...state,
        otp: action.payload,
        error: null,
      };
    case LOGIN_WITH_OTP_ERROR:
      return {
        ...state,
        otp: null,
        error: action.payload,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case FORGOT_PASSWORD_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        message: action.payload,
        error: null,
      };
    case RESET_PASSWORD_ERROR:
      return {
        ...state,
        message: null,
        error: action.payload,
      };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        otp: action.payload,
        error: null,
      };
    case GET_PROFILE_ERROR:
      return {
        ...state,
        otp: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

